module.exports = "<div class=\"modal modal-fnji-weixin-srv\" v-show=\"value\" @click=\"hide()\">\r\n    <div class=\"modal-dialog\">\r\n        <div class=\"modal-content\">\r\n            <i class=\"u-icon u-icon-fnji-weixin\"></i>\r\n            <div style=\"font-size: 12px;padding-top: 10px;line-height: 20px;letter-spacing: 1px;\">微信扫描二维码关注梵几服务号<br>可以进行预约</div>\r\n\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/mac/001.code/xbigger-web/xbigger/fnjinew/build-v2/node_modules/text-loader!../common/modal/fnji-weixin-srv.html
// module id = 53
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24